import IsbnVerify from '@shippack/isbn-verify'

export const isISBNValid = value => {
  if (value) {
    const isbnVerify = new IsbnVerify(value)
    return isbnVerify.isValid()
  }
  return true
}
